export const homeObjOne = {
  headline: "ژانر جنایی",
  description:
    "ادبیات داستانی جنایی یکی از سبک‌های ادبی است که اعمال مجرمان و انگیزه‌های آنان را روایت می‌کند. این سبک خود به چندین زیر سبک از جمله ادبیات پلیسی تقسیم می‌شود.در داستان‌های جنایی معمولاً قتل یا قتل‌هایی اتفاق می‌افتد و فرد یا افرادی مأمور می‌شوند که راز آن قتل‌ها را کشف کنند. اغلب این داستان‌ها هم به‌منظور قصه‌گویی صرف و سرگرمی نوشته می‌شوند مگر آنکه داستان یک شخصیت محوری داشته باشد که نویسنده بتواند به جنبه‌های پیچیده شخصیت او نزدیک شود، مثل سکوت بره‌ها یا بعضی داستان‌های دیگر مشابه آنکه در آن‌ها داستان از جنبه جنایی صرف بیرون آمده و شخصیت‌ها عمق پیدا کرده‌اند",
  imgStart: "",
  img: require("./images/hero.png").default,
  alt: "تصویر کتاب جنایی",
  start: "",
};
